import { ProvideCourseCenterContext } from '@/pages/course-center/container/CourseCenterContext'
import CourseCenterRoot from '@/pages/course-center/components/CourseCenterRoot'
import { withServerSideProps } from '@/containers/withServerSideProps'
import { APP_LOCALE } from '@/constants/define'
import { platformPage } from '@/services/get-serverside-props/platform'

export default function CourseCenterPage() {
  return (
    <ProvideCourseCenterContext isPlatform>
      <CourseCenterRoot />
    </ProvideCourseCenterContext>
  )
}

const getServerSideProps = withServerSideProps(
  platformPage,
  APP_LOCALE === 'zh_CN' ? ['footerLink'] : undefined
)

export { getServerSideProps }
